import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=672eee65&"
var script = {}
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=672eee65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports